import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";

export const spotlightRoutes: PermissionedRouteObject[] = [
  {
    handle: { breadcrumb: "Spotlights" },
    children: [
      {
        index: true,
        lazy: async () => {
          const { SpotlightsPage } = await import("./spotlights-page");
          return { Component: SpotlightsPage };
        },
      },
      {
        path: "new",
        lazy: async () => {
          const { SpotlightTemplateSelection } =
            await import("./spotlight-template-selection");
          return { Component: SpotlightTemplateSelection };
        },
      },
      {
        path: "builder/:spotlightId",
        lazy: async () => {
          const { SpotlightBuilder } = await import("./spotlight-builder");
          return { Component: SpotlightBuilder };
        },
      },
    ],
  },
];
